export default {
  allTaxes: [],
}
